/**
 * Style constants for the wedding website
 * This file contains shared values like colors, spacing, and breakpoints
 */

// Color palette
export const colors = {
  // Primary colors
  primary: {
    main: '#2D3047',
    light: '#484D6D',
    dark: '#1A1C2E',
  },
  // Secondary colors
  secondary: {
    main: 'rgba(187, 138, 101, 0.5)',
    light: '#F2A07B',
    dark: '#AF632A',
    darkSolid: 'rgba(175, 99, 42, 1)',
    darkHover: 'rgba(187, 138, 101, 1)',
  },
  // Background colors
  background: {
    default: '#FFFFFF',
    paper: '#F5F5F5',
    card: '#faf7f2',
    overlay: 'rgba(255, 255, 255, 0.3)',
  },
  // Text colors
  text: {
    primary: '#000000',
    secondary: '#666666',
  },
};

// Typography
export const typography = {
  fontFamilies: {
    primary: '"Playfair Display", serif',
    secondary: '"Open Sans", sans-serif',
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
};

// Spacing
export const spacing = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 6,
  xxl: 8,
};

// Border radius
export const borderRadius = {
  small: 2,
  medium: 4,
  large: 8,
  button: 25,
  card: 8,
};

// Shadows
export const shadows = {
  card: '0px 4px 12px rgba(0, 0, 0, 0.1)',
};

// Breakpoints (matching MUI defaults)
export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

// Z-index
export const zIndex = {
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
};
